(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["character-demo"] && !Shopify.designMode) return;
  try {
    (function () {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    function cast() { return document.documentElement.getAttribute('data-cast') === 'him' ? 'him' : 'her'; }

    function setup(root) {
      if (root.demo) return;
      var video = root.querySelector('[data-demo-video]');
      var beats = Array.prototype.slice.call(root.querySelectorAll('[data-beat]'));
      var loaded = '';   // cast whose loop is set on the video
      var inView = false;

      function progress(p) {
        beats.forEach(function (b) { b.toggleAttribute('data-active', p >= parseFloat(b.getAttribute('data-from')) && p < parseFloat(b.getAttribute('data-to'))); });
        root.dispatchEvent(new CustomEvent('demo:progress', { detail: { progress: p } }));
      }
      // The current cast's loop on the video; the poster shows until it plays.
      function load() {
        var c = cast();
        if (loaded === c) return;
        loaded = c;
        video.poster = root.getAttribute('data-poster-' + c);
        video.src = root.getAttribute('data-video-' + c);
        video.hidden = false;
        video.load();
      }
      function play() {
        if (mq.matches || document.hidden || !inView) return;
        load();
        var p = video.play();
        if (p && p.catch) p.catch(function () { root.removeAttribute('data-playing'); });
      }
      function pause() { if (!video.paused) video.pause(); }

      video.addEventListener('playing', function () { root.setAttribute('data-playing', ''); });
      video.addEventListener('pause', function () { root.removeAttribute('data-playing'); });
      video.addEventListener('timeupdate', function () { if (video.duration) progress(video.currentTime / video.duration); });

      root.demo = { play: play, pause: pause };

      function arm() {
        if (mq.matches) return; // reduced motion: the poster, nothing fetched
        // Within one viewport: fetch the loop. In view: play. Out of view: pause.
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) load();
        }, { rootMargin: '100% 0px' }).observe(root);
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) play(); else pause();
        }, { threshold: 0.1 }).observe(root);
      }
      if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm);

      document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });
      document.addEventListener('strippers:cast', function () {
        if (!loaded) return;
        var wasPlaying = !video.paused;
        loaded = '';
        load();
        if (wasPlaying) play();
      });
    }

    function init(scope) {
      if (scope.matches && scope.matches('[data-demo]')) setup(scope);
      else scope.querySelectorAll('[data-demo]').forEach(setup);
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    // The CLI's hot reload replaces a section's outerHTML silently: watch for a fresh node.
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) init(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
